import React from 'react';
import CategoryCourseTile from './CategoryCourseTile';
import './tiles.scss';

function TileHolder({ tileContents }) {
    // Use optimized images from public directory for better performance
    const images = [
        "/assets/images/optimized/Training/image1-medium.jpeg",
        "/assets/images/optimized/Training/image2-medium.jpeg",
        "/assets/images/optimized/Training/image3-medium.jpeg",
        "/assets/images/optimized/Training/image4-medium.jpeg",
        "/assets/images/optimized/Training/image5-medium.jpeg",
        "/assets/images/optimized/Training/image6-medium.jpeg",
        "/assets/images/optimized/Training/image7-medium.jpeg",
        "/assets/images/optimized/Training/image8-medium.jpeg",
        "/assets/images/optimized/Training/image9-medium.jpeg",
        "/assets/images/optimized/Training/image10-medium.jpeg"
      ];

    const summariesWithImages = tileContents.map((tileContents, index) => ({
        ...tileContents,
        image: images[index % images.length],
      }));

    return (
        <div className="tile-holder">
          {summariesWithImages.map((summary) => (
            <CategoryCourseTile key={summary.id} {...summary}  />
          ))}
        </div>
      );
}

export default TileHolder;